/**
 * "In the booking app": the campaign banner as customers will see it, and an
 * example workshop with its price struck through.
 */
import { formatCampaignDollars } from '@bonsai/shared';

import { formDiscount, type CampaignFormValues } from './campaign-form';
import { SAMPLE_WORKSHOP, samplePriceAfter } from './campaign-preview';
import { CampaignPreviewBanner } from './CampaignPreviewBanner';

export function CampaignBookingPreview({ values }: { values: CampaignFormValues }) {
  const discount = formDiscount(values);
  const listPrice = formatCampaignDollars(SAMPLE_WORKSHOP.priceCents);
  return (
    <section
      className="nb-card"
      aria-label="In the booking app"
      style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
    >
      <div className="nb-eyebrow">In the booking app</div>
      <CampaignPreviewBanner values={values} />
      <div
        style={{
          border: '1px solid var(--nb-border)',
          borderRadius: 10,
          padding: '11px 13px',
          display: 'flex',
          alignItems: 'baseline',
          gap: 8,
        }}
      >
        <span style={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 700 }}>
          {SAMPLE_WORKSHOP.title}
        </span>
        {discount && (
          <s className="nb-tabular" style={{ fontSize: 12.5, color: 'var(--nb-faint)' }}>
            {listPrice}
          </s>
        )}
        <span
          className="nb-tabular"
          style={{ fontSize: 17, fontWeight: 800, color: 'var(--nb-primary-2)' }}
        >
          {discount ? formatCampaignDollars(samplePriceAfter(discount)) : listPrice}
        </span>
      </div>
      <div style={{ fontSize: 11, color: 'var(--nb-faint)' }}>Example workshop at {listPrice}</div>
    </section>
  );
}
